import React from "react";
import header from "../../images/Consent/SiksikaMarchMadness/header.png";

export class SiksikaMarchMadnessAssent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      agree_to_study: null,
      participant_name: "",
      consent_phone_number: "",
      witness_name: ""
    };
  }

  validateComplete = () => {
    const { participant_name, witness_name, agree_to_study } = this.state;

    let data = this.state;
    console.log(agree_to_study);

    if (participant_name && witness_name && agree_to_study === true) {
      data.formValid = true;
    } else {
      data.formValid = false;
    }

    this.props.handleChange(data);
  };

  handleChange = event => {
    const { name, value } = event.target;
    if (["witness_name", "participant_name"].includes(name)) {
      this.setState(
        {
          [name]: value
        },
        this.validateComplete
      );
    } else if (["agree_to_study"].includes(name)) {
      this.setState(
        {
          [name]: value === "true"
        },
        this.validateComplete
      );
    }
  };

  render() {
    const { participant_name, witness_name } = this.state;

    const { translate } = this.props;

    return (
      <div>
        <img
          src={header}
          alt="header"
          style={{
            display: "block",
            marginLeft: "auto",
            width: 115
          }}
        />
        <h4>UNIVERSITY OF CALGARY</h4>
        <h4>GENERAL ASSENT TO PARTICIPATE IN RESEARCH</h4>
        <h5 className="lead mt-3">{translate("calgaryConsent.t2")}:</h5>
        Siksika March Madness
        <h5 className="lead mt-3">SPONSOR:</h5>
        University of Calgary
        <h5 className="lead mt-3">FUNDER:</h5>
        <p>
          Canadian Institutes of Health Research (CIHR) - You-CAN (Youth
          Concussion Awareness Network) SHRed Concussions (Surveillance in High
          School and Community Sport to Reduce Concussions and their
          Consequences): Canadian Youth Informing Best Practice and Policy in
          the Prevention of Sport-related Concussions
        </p>
        <h5 className="lead mt-3">INVESTIGATORS:</h5>
        <table style={{ borderCollapse: "collapse", marginLeft: "1rem" }}>
          <tr>
            <td style={{ width: "300px", padding: "4px 10px" }}>
              Dr. Carolyn Emery
            </td>
            <td style={{ padding: "4px 10px" }}>403.220.4608</td>
          </tr>
          <tr>
            <td style={{ width: "300px", padding: "4px 10px" }}>
              Dr. Stephen West
            </td>
            <td style={{ padding: "4px 10px" }}>403.220.5332</td>
          </tr>
        </table>
        <table
          style={{ borderCollapse: "collapse", margin: "1rem 0 1rem 1rem" }}
        >
          <tr>
            <td style={{ width: "300px", padding: "4px 10px" }}>
              Research Coordinators
            </td>
            <td style={{ padding: "4px 10px" }}>
              shred.concussions@ucalgary.ca
            </td>
          </tr>
          <tr>
            <td style={{ width: "300px", padding: "4px 10px" }}>
              Lab Manager - Shane Esau
            </td>
            <td style={{ padding: "4px 10px" }}>403.220.6336</td>
          </tr>
        </table>
        <h5 className="lead mt-3">INTRODUCTION</h5>
        <p>
          A research study is a way to find out new information about something.
          People don't need to participate in a research study if they don't
          want to participate.
        </p>
        <p>
          You can talk with your parents or guardians before you decide. We will
          also ask your parents or guardians to give their permission for you to
          take part in this study. But even if your parents or guardians say
          “yes” you can still decide not to do this.
        </p>
        <h5 className="lead mt-3">WHY IS THIS STUDY BEING DONE?</h5>
        <p>
          We want to learn more about concussions and other sports injuries in
          Siksika Nation. We are asking you to be in the study because you are
          participating in the March Madness tournament in basketball or ice
          hockey, which are high concussion sports. Up to 100 people will be in
          this study.
        </p>
        <h5 className="lead mt-3">
          WHAT WILL HAPPEN IF I TAKE PART IN THIS STUDY?
        </h5>
        <p>
          If you decide to take part in this study, here are some things that
          will happen:
        </p>
        <ul>
          <li>
            You will be asked to fill out some questionnaires. They will ask
            about the sports you play, any injuries you had before, and some
            things about your life.
          </li>
          <li>
            You will be asked to report any injuries or concussions you get
            during your participation in the study.
          </li>
          <li>
            If you get a concussion or a serious injury, our research team will
            help you. This may include seeing a nurse practitioner or another
            health-care worker at Siksika Health Services, or a doctor at one of
            our partner clinics. As part of follow up, a research team member
            may contact you via phone, text (pinger) or email.
          </li>
          <li>
            Tournament organizers have agreed to allow video to be taken of ice
            hockey and basketball events. All video will be anonymous to
            individual participants
          </li>
        </ul>
        <h5 className="lead mt-3">
          ARE THERE ANY POTENTIAL RISKS OR DISCOMFORTS THAT I CAN EXPECT FROM
          THIS STUDY?
        </h5>
        <p>
          There are limited risks to you for participating in this study. The
          questionnaires have been used with other kids in sports before. No
          problems or bad side effects have happened. Some questions may feel
          personal. If you are not comfortable answering them, you don't have
          to.
        </p>
        <h5 className="lead mt-3">WILL THE STUDY HELP ME?</h5>
        <p>
          If you get a concussion, we will help you see a health care
          professional. This person knows how to diagnose and treat concussions.
        </p>
        <h5 className="lead mt-3">WILL THE STUDY HELP OTHERS?</h5>
        <p>
          This study may help us learn more about concussions and sports
          injuries. What we learn could help other kids and athletes stay safer
          in the future.
        </p>
        <h5 className="lead mt-3">
          WHO WILL SEE THE INFORMATION COLLECTED ABOUT ME?
        </h5>
        <p>
          The information collected about you during this study will be kept
          safely locked up. Nobody will read it except the people doing the
          research. The study information about you will not be given to your
          parents/guardians. The researchers won't tell your friends or anyone
          else that you are in this study or share any information about you.
        </p>
        <h5 className="lead mt-3">DO I HAVE TO BE IN THE STUDY?</h5>
        <p>
          You don't have to be in the study. It is up to you. No one will be
          upset if you don't want to do this study. You can say yes, or you can
          say no. You can also take more time to think about being in the study.
        </p>
        <p>
          If you want to stop, then all you have to do is tell us you want to
          stop. No one will be mad at you if you don't want to be in the study,
          or if you say yes now then want to stop later.
        </p>
        <h5 className="lead mt-3">
          WHO CAN I CONTACT IF I HAVE QUESTIONS ABOUT THIS STUDY?
        </h5>
        <h4 className="lead mt-3">The Research Team:</h4>
        <p>
          You can ask any questions that you may have about the study. If you
          have a question later that you didn't think of now, either you can
          call or have your parents Shane Esau at 403.220.6336. You can take
          more time to think about the study, and you can talk more with your
          parents before you decide.
        </p>
        <hr />
        <h5 className="lead mt-3">
          WOULD YOU LIKE TO BE IN THIS RESEARCH STUDY?
        </h5>
        If you decide to be in the study, then please write your name below. You
        can change your mind and stop being part of the study at any time. All
        you have to do is tell us. It's okay. The researchers and your parents
        won't be upset with you.
        <div className="form-check" style={{ marginTop: "1rem" }}>
          <label className="form-check-label">
            <input
              className="form-check-input"
              type="radio"
              name="agree_to_study"
              id="agree_to_study_yes"
              value={true}
              onClick={this.handleChange}
            />
            Yes, I want to be in this study
          </label>
        </div>
        <div className="form-check" style={{ marginBottom: "1rem" }}>
          <label className="form-check-label">
            <input
              className="form-check-input"
              type="radio"
              name="agree_to_study"
              id="agree_to_study_no"
              value={false}
              onClick={this.handleChange}
            />
            No, I don't want to do this
          </label>
        </div>
        <div className={"form-group row"}>
          <label className="col-lg-4 col-form-label">
            Name of participant:
          </label>
          <div className={"col-lg-4 mb-2"}>
            <input
              type="text"
              className="form-control"
              id="participant_name"
              name="participant_name"
              value={participant_name}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className={"form-group row"}>
          <label className="col-lg-4 col-form-label">
            Name of Person who received assent:
          </label>
          <div className={"col-lg-4 mb-2"}>
            <input
              type="text"
              className="form-control"
              id="witness_name"
              name="witness_name"
              value={witness_name}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <hr />
      </div>
    );
  }
}
